import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type DestinationReportingIndexRoute from 'lumen/routes/destination/reporting/index';
import type { ModelFrom } from 'lumen/utils/routes';

export default class DestinationReportingIndexController extends Controller {
  declare model: ModelFrom<DestinationReportingIndexRoute>;

  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get helpArticles() {
    return [
      {
        title: this.intl.t(
          'custom_reporting.learn.scheduling_and_sending.title',
        ),
        description: this.intl.t(
          'custom_reporting.learn.scheduling_and_sending.description',
        ),
        illustration: '40x40_scheduling' as const,
        cta: {
          label: this.intl.t(
            'custom_reporting.learn.scheduling_and_sending.cta',
          ),
          url: 'http://help.mylighthouse.com/en/articles/9230760-scheduling-and-sending-dashboards-in-custom-reporting',
        },
      },
      {
        title: this.intl.t('custom_reporting.learn.exporting_data.title'),
        description: this.intl.t(
          'custom_reporting.learn.exporting_data.description',
        ),
        illustration: '40x40_export-data' as const,
        cta: {
          label: this.intl.t('custom_reporting.learn.exporting_data.cta'),
          url: 'http://help.mylighthouse.com/en/articles/9230757-exporting-data-from-your-custom-reporting',
        },
      },
    ];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get recentlyViewedDashboards() {
    return this.model.recentDashboards.lastSuccessful?.value;
  }
}
